import { hasPermission } from '@apply/ui';
import { WatchlistActionType, LoanStatusType } from '@apply/constants';
import { PermissionType } from '@apply/constants';

export const getWatchlistActions = (wlLoan: {
    loanId: number;
    propertyId: number;
    isLocked: boolean;
    watchlistId: number;
    groupId: number;
    statusId: number;
}) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    if (hasPermission(PermissionType.WatchlistView) || hasPermission(PermissionType.WatchlistEdit)) {
        let itemType = 'Loan';
        if (wlLoan.propertyId) {
            itemType = 'Property';
        }
        actions.push({
            id: WatchlistActionType.WatchlistEntryDetails,
            text: !wlLoan.isLocked && hasPermission(PermissionType.WatchlistEdit) ? `Edit ${itemType}` : `View ${itemType}`,
            loanId: wlLoan.loanId,
            propertyId: wlLoan.propertyId,
            watchlistId: wlLoan.watchlistId,
            stylingMode: 'contained',
        });

        if (wlLoan.groupId) {
            actions.push({
                id: WatchlistActionType.WatchlistEditGroup,
                text: hasPermission(PermissionType.WatchlistEdit) ? 'Edit Group' : 'View Group',
                loanId: wlLoan.loanId,
                watchlistId: wlLoan.watchlistId,
                groupId: wlLoan.groupId,
                stylingMode: 'contained',
                //disabled: !wlLoan.groupId
            });
        } else {
            actions.push({
                id: WatchlistActionType.WatchlistEditGroup,
                text: 'New Group',
                loanId: wlLoan.loanId,
                watchlistId: wlLoan.watchlistId,
                groupId: wlLoan.groupId,
                stylingMode: 'contained',
                disabled: !hasPermission(PermissionType.WatchlistEdit),
            });
        }

        if (wlLoan.loanId && (wlLoan.statusId === LoanStatusType.Outstanding || wlLoan.statusId === LoanStatusType.Repaid)) {
            actions.push({
                id: WatchlistActionType.LoanAuditHistory,
                text: 'Loan Audit History',
                loanId: wlLoan.loanId,
                stylingMode: 'contained',
            });
        }
    }

    // actions.push({
    //   id: WatchlistActionType.LoanDetails,
    //   text: 'Loan Details',
    //   loanId: wlLoan.loanId,
    //   stylingMode: 'contained',
    // });

    return actions;
};
